export default {"src":"/_next/static/media/gradient_income_expenses.11ecb361.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};